import { useMemo, useState } from "react";
import CardSpinner from "./CardSpinner";

const ordenarFotosComCapaPrimeiro = (fotos = []) =>
  [...fotos].sort((a, b) => {
    if (a?.e_capa && !b?.e_capa) return -1;
    if (!a?.e_capa && b?.e_capa) return 1;
    return new Date(a?.createdAt || 0) - new Date(b?.createdAt || 0);
  });

const ProdutoCard = ({ produto, aoClicar }) => {
  const [loaded, setLoaded] = useState(false);

  const primeiraFoto = useMemo(() => {
    const fotosOrdenadas = ordenarFotosComCapaPrimeiro(produto?.fotos || []);
    return fotosOrdenadas[0]?.url;
  }, [produto?.fotos]);

  return (
    <div
      className="w-full overflow-hidden rounded-xl shadow-md cursor-pointer"
      onClick={aoClicar}
    >
      <div className="w-full relative aspect-[3/4] bg-gray-100">
        {!loaded && (
          <div className="absolute inset-0">
            <CardSpinner />
          </div>
        )}

        {primeiraFoto ? (
          <img
            src={`${process.env.REACT_APP_UPLOADS_URL}${primeiraFoto}`}
            alt={produto.descricao}
            className={`w-full h-full object-cover transition-opacity duration-500 ${
              loaded ? "opacity-100" : "opacity-0"
            }`}
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
          />
        ) : (
          <div className="w-full h-full bg-gray-200" />
        )}
      </div>
    </div>
  );
};

export default ProdutoCard;
